export default "__VITE_ASSET__C7LEwFm5__"